class NSSArticleRelatedSlider extends HTMLElement {
  constructor() {
    super();

    this.debug = false;

    this.swiper = null;
  }

  connectedCallback() {
    if (this.debug) console.log("[NSS][Article Related] Connected.");

    this.initSwiper();
  }

  initSwiper() {
    if (this.swiper) return;

    const carouselEl = this.querySelector(".swiper");
    if (!carouselEl) return;

    this.swiper = new Swiper(carouselEl, {
      autoHeight: false,
      grabCursor: true,
      // 'auto' respects the slide's CSS width (380px desktop / 320px mobile)
      // so the neighbouring card peeks at the edge.
      slidesPerView: "auto",
      spaceBetween: 20,
      watchOverflow: true,

      breakpoints: {
        990: {
          spaceBetween: 24,
        },
      },

      a11y: {
        enabled: true,
        // Slides are <li>; Swiper's default role="group" breaks the list semantics.
        slideRole: null,
      },

      scrollbar: {
        el: this.querySelector(".nss-article-related__scrollbar"),
        draggable: true,
      },

      navigation: {
        prevEl: this.querySelector(".nss-article-related__btn--prev"),
        nextEl: this.querySelector(".nss-article-related__btn--next"),
      },
    });
  }

  disconnectedCallback() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }
}

if (!customElements.get("nss-article-related-slider")) {
  customElements.define("nss-article-related-slider", NSSArticleRelatedSlider);
}
